import { useTranslation } from 'next-i18next';
import { CvDetailInterface } from '@components/templates/cv/interface/CvDetailInterface';
import Link from 'next/link';

/**
 * @description Component to render the top link anchors to navigate to different sections of the CV.
 * @param cvDetail - the cv detail object
 */
export const TopAnchorLinks = ({ cvDetail }: CvDetailInterface) => {
  // Translation
  const { t } = useTranslation('common');


  // Render component
  // ******************************************************
  return (
    <section className="w-full min-w-full  gap-5 overflow-x-scroll border-b bg-surface-50 py-3 pr-5 lg:hidden">

      <div className="container mx-auto">
        <div className="flex gap-5">
          <a
            href="#about-me"
            className="block min-w-max cursor-pointer text-sm font-normal text-primary hover:underline lg:hidden"
          >
            {t('cv.detail.topAnchors.who-am-i')}
          </a>
          {cvDetail?.experiences && (
            <a
              href="#experience"
              className="block min-w-max cursor-pointer text-sm font-normal text-primary hover:underline lg:hidden"
            >
              {t('cv.detail.topAnchors.experience')}
            </a>
          )}

          {(cvDetail?.application?.evaluation || cvDetail?.evaluation) && (
            <a
              href="#evaluateBia"
              className="min-w-max cursor-pointer text-sm font-normal text-primary hover:underline"
            >
              {t('cv.detail.topAnchors.evaluation')}
            </a>
          )}
          {!cvDetail?.isOwnCV && (
            <a
              href="#similarCandidates"
              className="min-w-max cursor-pointer text-sm font-normal text-primary hover:underline"
            >
              {t('label-cv-tab-similar')}
            </a>
          )}
        </div>
      </div>
    </section>

  );
};
